import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Austria",
  "use": "icon-Austria-usage",
  "viewBox": "0 0 1536 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1536 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-Austria\"><path d=\"M16 16h1504v992H16z\" fill=\"#FFFFFF\" p-id=\"12027\" /><path d=\"M0 0h1536v339.2H0z m0 684.8h1536V1024H0z\" fill=\"#FF002D\" p-id=\"12028\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol